import React from 'react';
import PropTypes from 'prop-types';

import PageHeader from '../components/PageHeader';
import VideoBlock from '../components/VideoBlock';

const Videos = ({ data }) => {

  const videos = data.videosMarkdown.edges;

  const renderVideos = (videos) => {
    return Object.keys(videos).map( video => {

      const currentVideo = videos[video].node;
      const { title, link, description } = currentVideo.frontmatter;
      
      return (
        <VideoBlock
          key={video}
          title={title}
          link={link}
          description={description}
        />
      );
    });
  }

  return(
    <div className="videos">
        <div className="main">
         <PageHeader title="Retrouvez ici toutes nos vidéos" />
         { renderVideos(videos) }
        </div>
    </div>
  );
}

Videos.PropTypes = {
    data: PropTypes.object,
};

export default Videos;

export const query = graphql`
  query allVideosQuery {
    videosMarkdown: allMarkdownRemark(
      filter: {fileAbsolutePath: {regex: "/(videos)/.*\\.md$/"}}
    ) {
      edges {
        node {
          frontmatter {
            title
            link
            description
          }
        }
      }
    } 
  }
`;


// WEBPACK FOOTER //
// ./src/pages/videos.jsx